import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchPurchaseOrders, setDefaultDays, setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { fetchReceiveHistoryByDate, selectReceiveHistory, resetCurrentReceiveHistory, fetchReceiveHistory, fetchReceiveHistoryDetailRecord, voidReceiving, resetDeleteStatus } from '../../actions/receive_actions';
import { autoPutaway } from '../../actions/putAway_actions';

import { checkPermission } from '../../actions/settings_actions';
import { printWarehouseReceive, fetchLineLabel } from '../../actions/print_actions';
import { setConfirmPasscodeModalVisibility, setPasscodeVerificationStatus } from '../../actions/baseModal_actions';
import ReceiveHistoryList from '../../components/Inventories/receiveHistoryList';

const receiveHistoryList = reduxForm({
  form: 'receiveHistoryList',
  destroyOnUnmount: false,
})(ReceiveHistoryList);

const selector = formValueSelector('receiveHistoryList');

function mapStateToProps(state) {
    const Days = selector(state, 'Days');
    const FromDate = selector(state, 'FromDate');
    const ToDate = selector(state, 'ToDate');
    return {
        Days,
        FromDate,
        ToDate,
        currentReceiveHistory: state.receives.fetchedReceiveHistory,
        isfetchingReceiveHistory: state.receives.isfetchingReceiveHistory,
        isLoading: state.receives.isfetchingReceiveHistory,
        error: state.receives.fetchReceiveHistoryError,
        currentReceiveHistoryDetail: state.receives.fetchedReceiveHistoryDetailRecord,

        voidStatus: state.receives.voidStatus,
        voidIsLoading: state.receives.voidIsLoading,
        voidError: state.receives.voidError,

        checkingPermission: state.settings.checkingPermission,
        checkPermissionSuccess: state.settings.checkPermissionSuccess,
        checkPermissionFailure: state.settings.checkPermissionFailure,

        requestingWarehouseReceivePdf: state.print.requestingWarehouseReceivePdf,
        warehouseReceivePdf: state.print.warehouseReceivePdf,
        passcodeVerified: state.baseModals.confirmPasscodeModal.verified,
      };
}


export default connect(mapStateToProps, {
    setDefaultDays,
    setDefaultOfForm,
    fetchReceiveHistoryByDate,
    selectReceiveHistory,
    resetCurrentReceiveHistory,
    fetchPurchaseOrders,
    fetchReceiveHistory,
    fetchReceiveHistoryDetailRecord,
    voidReceiving,
    autoPutaway,
    checkPermission,
    resetDeleteStatus,
    printWarehouseReceive,
    setConfirmPasscodeModalVisibility,
    setPasscodeVerificationStatus,
    fetchLineLabel,
})(receiveHistoryList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/receiveHistoryList.jsx